import { render, staticRenderFns } from "./activeSubjectStatis.vue?vue&type=template&id=0c927d4c&scoped=true"
import script from "./activeSubjectStatis.vue?vue&type=script&lang=js"
export * from "./activeSubjectStatis.vue?vue&type=script&lang=js"
import style0 from "./activeSubjectStatis.vue?vue&type=style&index=0&id=0c927d4c&prod&lang=scss&scoped=true"
import style1 from "./activeSubjectStatis.vue?vue&type=style&index=1&id=0c927d4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c927d4c",
  null
  
)

export default component.exports